exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-wrap[data-v-25ad32bb] {\n  text-align: right;\n  padding: 20px;\n}\n.config-value[data-v-25ad32bb] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: relative;\n}\n", ""]);

// exports
